/* import __COLOCATED_TEMPLATE__ from './sales-recommended-landing.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();